/* eslint-disable  prefer-promise-reject-errors */
/* eslint-disable import/order */
/* eslint-disable no-else-return */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable react-hooks/exhaustive-deps */

import { Button as AntdButton, Col, Form, Input, InputNumber, List, message, Modal, Row, Typography } from 'antd';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { v4 as uuid } from 'uuid';
import FloatLabel from '~/components/Form/FloatLabel';

import { Checkbox, PhoneNumberFormItem } from '~/components';
import Button from '~/components/Button';
import FormDrawer from '~/components/FormDrawer';
import CustomTooltip from '~/components/OpenedToolTip';
import { useCreateCardholder, useSendInvitaion } from '~/controllers/cardholder';
import CardHolderDetails from '~/pages/cardholder/details';
import { Person } from '~/types/Person';
import { isSales } from '~/utils/getDecodedJwt';
import phoneValidation from '~/utils/phoneValidation';
import { capitalizeWords } from '~/utils/validateCharacters';
import { physicalCards } from '..';

function CardHolderModal(props: any) {
  const { setCardholderModal, openCardholderModal, addElement, checkCardholderValidation, allProductsLists } = props;

  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [isSASloading, setIsSASloading] = useState(false);
  const [isSaveloading, setIsSaveloading] = useState(false);
  const [btnClicked, setBtnClicked] = useState('');

  const sales = isSales();
  const onClose = () => cancelHandler();
  const open = openCardholderModal?.value;
  const formName = sales ? 'addCardholder' : '/cardHolder/details';

  const createCardholder = useCreateCardholder();
  const isItPhysical = physicalCards.includes(openCardholderModal?.productKey);
  const sendInvitaion = useSendInvitaion();

  function saveHandler(value?: any) {
    const addCardHolderValues = value || form.getFieldsValue();
    if (isItPhysical) {
      try {
        const isError = checkCardholderValidation(
          'cardholder-section',
          'cardholder',
          {
            cardholder: `${addCardHolderValues.firstName} ${addCardHolderValues.lastName}`,
          },
          addCardHolderValues,
        );
        if (isError?.value) {
          return message.error(isError?.message);
        }

        return createCardholder.mutateAsync(addCardHolderValues).then((values) => {
          const cardHoldervalues = { ...addCardHolderValues, id: values?.id, status: values?.status };
          const isError = addElement(
            'cardholder-section',
            'cardholder',
            {
              cardholder: `${addCardHolderValues.firstName} ${addCardHolderValues.lastName}`,
            },
            { ...cardHoldervalues, uuid: uuid(), sendInvitationCounter: btnClicked === 'SaveAndSend' ? 1 : 0 },
          );

          if (isError?.value) {
            void message.error(isError?.message);
          } else {
            message.success('Cardholder saved successfuly');
            if (btnClicked === 'SaveAndSend') {
              const finalObj = { ...addCardHolderValues };
              const sendInvitaionBody = {
                lastName: finalObj.lastName,
                firstName: finalObj.firstName,
                email: finalObj.email,
                phoneNumber: finalObj.mobile,
              };
              const invitationSent = sendInvitaion.mutateAsync(sendInvitaionBody);
              message.success('Invitation sent  successfuly ');
            }
            setCardholderModal(false);
            form.resetFields();
          }
        });
      } catch (error) {
        return error;
      }
    } else {
      const isError = addElement(
        'cardholder-section',
        'cardholder',
        {
          cardholder: `${addCardHolderValues.nameOfVirtualCardAccount}`,
        },
        addCardHolderValues,
      );

      if (isError?.value) {
        return message.error(isError?.message);
      }
      setCardholderModal(false);
      form.resetFields();
    }

    return null;
  }
  function cancelHandler() {
    form.resetFields();

    setCardholderModal((prev: any) => {
      return { ...prev, value: false };
    });
  }

  const [matchingContactList, setMatchingContactList] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedContact, setSelectedContact] = useState<Person>();
  const [resolveMatchingPromise, setResolveMatchingPromise] = useState<
    ((value: { choice: 'new' | 'select'; selectedContact?: Person }) => void) | null
  >(null);

  const handleMatchingModalAsync = async () => {
    return new Promise<{ choice: 'new' | 'select'; selectedContact?: Person }>((resolve) => {
      setResolveMatchingPromise(() => resolve);
    });
  };

  const handleCreateNewContact = () => {
    if (resolveMatchingPromise) {
      resolveMatchingPromise({ choice: 'new' });
      setResolveMatchingPromise(null);
    }
    setModalOpen(false);
    setMatchingContactList([]);
  };

  const handleSelectContact = () => {
    if (resolveMatchingPromise && selectedContact) {
      resolveMatchingPromise({ choice: 'select', selectedContact });
      setResolveMatchingPromise(null);
    }
    setModalOpen(false);
    setMatchingContactList([]);
  };

  if (sales && isItPhysical) {
    return (
      <FormDrawer
        id="cardHolderDrawer"
        open={open}
        onClose={onClose}
        title={t('Add new Cardholder')}
        formName={formName}
      >
        <Modal
          open={modalOpen}
          title="This contact matches existing contacts. If you wish to update any of the contacts below, please select the contact you want to update, or create a new contact"
          onCancel={() => {
            setModalOpen(false);
            setMatchingContactList([]);
            setResolveMatchingPromise(null);
            setSelectedContact(undefined);
          }}
          footer={[
            <AntdButton key="newContact" onClick={handleCreateNewContact}>
              {t('Create New Contact')}
            </AntdButton>,
            <AntdButton key="select" type="primary" disabled={!selectedContact} onClick={handleSelectContact}>
              {t('Select')}
            </AntdButton>,
          ]}
        >
          <List
            dataSource={matchingContactList}
            renderItem={(item: Person) => (
              <List.Item
                onClick={() => setSelectedContact(item)}
                style={{
                  cursor: 'pointer',
                  backgroundColor: selectedContact?.contactId === item.contactId ? '#e6f7ff' : 'transparent',
                  padding: '8px',
                  borderRadius: '4px',
                  whiteSpace: 'pre-wrap',
                  wordBreak: 'break-word',
                }}
              >
                {`Name: ${item.firstName} ${item.lastName}`}
                <br />
                {`Roles: ${item.userRoles?.join(' - ')}`}
              </List.Item>
            )}
          />
        </Modal>
        <CardHolderDetails
          isAdding
          setSelectedContact={setSelectedContact}
          setMatchingContactList={setMatchingContactList}
          setModalOpen={setModalOpen}
          handleMatchingModalAsync={handleMatchingModalAsync}
          onFinish={(value: any) => saveHandler(value)}
          cardHolderType={openCardholderModal?.productKey}
        />
      </FormDrawer>
    );
  }

  return (
    <ModalContianer>
      <Modal
        title={
          <Typography.Title style={{ fontSize: 38, marginBottom: 10 }} level={1}>
            {isItPhysical ? 'Add Card Details & Send Invitation' : 'Add Card Details '}
          </Typography.Title>
        }
        centered
        visible={openCardholderModal?.value}
        footer={null}
        okText="Save"
        width={900}
      >
        <Container>
          <Typography.Title style={{ marginBottom: '20px' }} level={5}>
            {t('PERSONAL DETAILS')}{' '}
          </Typography.Title>
          <Form onFinish={() => saveHandler()} initialValues={{}} form={form} name="cardholder-control">
            {!isItPhysical && (
              <>
                <Row gutter={0}>
                  <Col span={12}>
                    <Form.Item
                      rules={[
                        { required: true },
                        {
                          message: 'The name of the card should be two words',
                          validator: (_, value) => {
                            if (/\b[a-zA-Z]+\s[a-zA-Z]+\b/.test(value)) {
                              if (value.split(' ').length > 2) {
                                return Promise.reject();
                              }
                              return Promise.resolve();
                            }
                            return Promise.reject();
                          },
                        },
                        {
                          message: 'Cardholder name should be unique overall the products',
                          validator: (_, value) => {
                            const allProducts = Object.values(allProductsLists || {})?.flat();
                            const checkIfNameIsUnique = allProducts?.find(
                              (item: any) =>
                                item?.name.toLowerCase() === value.toLowerCase() && item.type === 'cardholder',
                            );
                            if (!checkIfNameIsUnique) {
                              return Promise.resolve();
                            }
                            return Promise.reject();
                          },
                        },
                        {
                          message: 'Exceed Maximum Length',
                          validator: (_, value) => {
                            if (value?.length > 21) {
                              return Promise.reject();
                            }
                            return Promise.resolve();
                          },
                        },
                      ]}
                      name="nameOfVirtualCardAccount"
                    >
                      <FloatLabel label={capitalizeWords(t('Name of virtual card account'))}>
                        <Input maxLength={21} />
                      </FloatLabel>
                    </Form.Item>
                  </Col>
                  <Col span={3}>
                    <CustomTooltip text={t('The name of the card should be two words')} width={250} />
                  </Col>
                </Row>
                <Row style={{ marginTop: '15px' }}>
                  <Col span={12}>
                    <Form.Item
                      rules={[
                        { required: true },
                        {
                          message: <p>alphabetic characters only allowed</p>,
                          validator: (_, value) => {
                            if (!/^[a-zA-Z\s]*$/g.test(value)) {
                              return Promise.reject();
                            }
                            return Promise.resolve();
                          },
                        },
                        {
                          message: 'Maximum 21 characters allowed',
                          validator: (_, value) => {
                            if (value?.length > 21) {
                              return Promise.reject();
                            }
                            return Promise.resolve();
                          },
                        },
                      ]}
                      name="companyEmbossing"
                    >
                      <FloatLabel label={t('companyEmbossing')}>
                        <Input maxLength={21} />
                      </FloatLabel>
                    </Form.Item>
                  </Col>
                  <Col span={3}>
                    <CustomTooltip text={t('Maximum 21 characters allowed')} width={250} />
                  </Col>
                </Row>
              </>
            )}

            {isItPhysical && (
              <>
                <Row gutter={30}>
                  <Col span={12}>
                    <Form.Item
                      rules={[
                        { required: true, message: <p style={{ paddingBottom: '8px' }}> Required</p> },
                        {
                          message: <p style={{ paddingBottom: '8px' }}> First name is not valid</p>,
                          validator: (_, value) => {
                            if (!/^[a-zA-Z ]*$/.test(value)) {
                              return Promise.reject();
                            }
                            return Promise.resolve();
                          },
                        },
                      ]}
                      name="firstName"
                    >
                      <FloatLabel label={capitalizeWords(t('firstName'))}>
                        <Input />
                      </FloatLabel>
                    </Form.Item>
                  </Col>

                  <Col span={12}>
                    <Form.Item
                      rules={[
                        { required: true, message: <p style={{ paddingBottom: '8px' }}> Required</p> },
                        {
                          message: <p style={{ paddingBottom: '8px' }}> Last name is not valid </p>,
                          validator: (_, value) => {
                            if (!/^[a-zA-Z ]*$/.test(value)) {
                              return Promise.reject();
                            }
                            return Promise.resolve();
                          },
                        },
                      ]}
                      name="lastName"
                    >
                      <FloatLabel label={t('Last Name')}>
                        <Input />
                      </FloatLabel>
                    </Form.Item>
                  </Col>
                </Row>
                <Row style={{ paddingBottom: '8px' }} gutter={30}>
                  <Col span={12}>
                    <Form.Item
                      rules={[
                        { required: true },
                        { type: 'email' },
                        // { validator: emailDuplicateCheck(listOfEmails) }
                      ]}
                      name="email"
                    >
                      <FloatLabel label={t('Email')}>
                        <Input />
                      </FloatLabel>
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <PhoneNumberFormItem
                      name="mobile"
                      rules={[
                        { required: true },
                        {
                          validator: phoneValidation(),
                        },
                      ]}
                    />
                  </Col>
                </Row>
                <Row style={{ paddingTop: '8px' }} gutter={30}>
                  <Col span={12}>
                    <Form.Item name="designation">
                      <FloatLabel label={t('Designation')}>
                        <Input />
                      </FloatLabel>
                    </Form.Item>
                  </Col>
                </Row>
              </>
            )}
            <Form.Item style={{ display: 'none' }} name={['sendInvitationCounter']} initialValue={0}>
              <InputNumber />
            </Form.Item>
            <Row style={{ alignItems: 'center', display: isItPhysical ? undefined : 'none' }}>
              <Col style={{ marginRight: '20px' }}>
                <Form.Item
                  rules={
                    isItPhysical
                      ? [
                          {
                            message: (
                              <div style={{ marginBottom: 60 }}>
                                {' '}
                                <p style={{ position: 'absolute', bottom: 0 }}> required</p>
                              </div>
                            ),
                            validator: (_, value) => {
                              if (!value) {
                                return Promise.reject();
                              }
                              return Promise.resolve();
                            },
                          },
                        ]
                      : undefined
                  }
                  valuePropName="checked"
                  initialValue={false}
                  name="hasConsent"
                >
                  <Checkbox />
                </Form.Item>
              </Col>
              <Col style={{ width: '80%' }}>
                <Typography.Paragraph>
                  {t(
                    'Customer confirm that has the consent from the above proposed cardholder to share their information with us',
                  )}
                </Typography.Paragraph>
              </Col>
            </Row>

            <Row justify="space-between" gutter={20}>
              <Col>
                <Button
                  loading={isSaveloading}
                  onClick={() => {
                    setBtnClicked('Save');
                    setIsSaveloading(true);
                    setTimeout(() => {
                      setIsSaveloading(false);
                    }, 1000);
                  }}
                  htmlType="submit"
                  id="Save$send"
                  type="primary"
                  className="footerBtn"
                >
                  Save
                </Button>
              </Col>
              {isItPhysical && (
                <Col>
                  <Button
                    onClick={() => {
                      setBtnClicked('SaveAndSend');
                      setIsSASloading(true);
                      setTimeout(() => {
                        setIsSASloading(false);
                      }, 1000);
                    }}
                    loading={isSASloading}
                    htmlType="submit"
                    id="Save$send"
                    type="primary"
                    className="footerBtn"
                  >
                    Save & Send Invitation
                  </Button>
                </Col>
              )}
              <Col>
                <Button onClick={() => cancelHandler()} id="cancel" className="footerBtn">
                  Cancel
                </Button>
              </Col>
            </Row>
          </Form>
        </Container>
      </Modal>
    </ModalContianer>
  );
}
const Container = styled.div<any>`
  .footerBtn {
    width: 218px;
    height: 44.844px;
  }
  .supplyerTypesSection {
    position: relative;
    display: flex;
    padding: 9px 12px;
    padding-top: 16px;
    align-items: flex-start;
    align-self: stretch;
    border-radius: 8px;
    border: 1px solid var(--alert-orange-2, #ffe58f);
    background: var(--alert-orange-3, #fffbe6);
  }
`;
const ModalContianer = styled.div<any>`
  .ant-modal {
    background-color: red;
  }
`;
export default CardHolderModal;
